import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons';
import { SlidingPane } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import { StyledHintTitle, StyledLightBulb, StyledQuestionHintContent, StyledTitle, TextContainer } from './question-hint.styles';
import type { QuestionHintProps } from './question-hint.types';
export const QuestionHint: FC<QuestionHintProps> = ({
  hint,
  isSlidingPaneOpen,
  setIsSlidingPaneOpen
}) => {
  const hintContent = <StyledQuestionHintContent>
      <StyledHintTitle>
        <StyledLightBulb icon={faLightbulbOn} />
        <StyledTitle>Question Hint</StyledTitle>
      </StyledHintTitle>
      <TextContainer>{hint}</TextContainer>
    </StyledQuestionHintContent>;
  return <SlidingPane isSlidingPaneOpen={isSlidingPaneOpen} setIsSlidingPaneOpen={setIsSlidingPaneOpen} data-sentry-element="SlidingPane" data-sentry-component="QuestionHint" data-sentry-source-file="question-hint.tsx">
      {hintContent}
    </SlidingPane>;
};